import axios from 'axios';
import config from '../config';

const API_BASE_URL = config.SITE_BASE_URL;

export const fetchBackups = async () => {
  const response = await axios.get(`${API_BASE_URL}/stores/backup`);
  return response.data.backups || [];
};

export const fetchBackupStats = async () => {
  const response = await axios.get(`${API_BASE_URL}/stores/backup/stats`);
  return response.data.stats || {};
};

export const fetchBackupDetails = async (backupName) => {
  const response = await axios.get(`${API_BASE_URL}/stores/backup/${backupName}`);
  return response.data.backup || {};
};

export const createBackup = async () => {
  const response = await axios.post(`${API_BASE_URL}/stores/backup`);
  return response.data;
};

export const deleteBackup = async (backupName) => {
  const response = await axios.delete(`${API_BASE_URL}/stores/backup/${backupName}`);
  return response.data;
};

export const cleanupOldBackups = async (keepMonths = 6) => {
  const response = await axios.post(`${API_BASE_URL}/stores/backup/cleanup?keepMonths=${keepMonths}`);
  return response.data;
};

export const downloadFullBackup = (backupName) => {
  window.open(`${API_BASE_URL}/stores/backup/${backupName}/download`, '_blank');
};

export const downloadDatabase = (backupName) => {
  window.open(`${API_BASE_URL}/stores/backup/${backupName}/download/database`, '_blank');
};

export const downloadImages = (backupName) => {
  window.open(`${API_BASE_URL}/stores/backup/${backupName}/download/images`, '_blank');
};